<template>
  <div :class="{ hdn: !showTicker }">
    <div class="d-inline-block" v-html="lastWeekInfo"></div>
    <div class="d-inline-block" v-html="notices"></div>
    <div class="d-inline-block" v-html="leagueInfo"></div>
    <!-- <div class="d-inline-block" v-html="sdInfo"></div> -->
  </div>
</template>

<script>
import numeral from "numeral";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Marquee",
  props: [],
  components: {},
  data: () => ({
    weekReady: false,
    leagueReady: false,
    sdReady: false,
    ntReady: false,
    showTicker: false,
  }),
  computed: {
    ...mapGetters(["latest_completed_week", "weeklyScores", "user", "league"]),
    lastWeekInfo() {
      if (this.latest_completed_week && this.weeklyScores && this.user) {
        const winner = this.weeklyScores[1].username;
        const winningScore = this.weeklyScores[1].tot_pts_won;
        const numRes = this.weeklyScores[1].num_correct_res;
        const numScr = this.weeklyScores[1].num_correct_scr;
        const you = Object.values(this.weeklyScores).find(
          (obj) => obj.user_id === this.user.id
        );
        const rank = this.ordinal(you.rank);

        let top_five = `Week ${this.latest_completed_week.play_week_num} Top Five: `;
        let top_five_arr = [];
        for (let i = 1; i < 6; i++) {
          let row = this.weeklyScores[i];
          top_five_arr.push(
            `${this.ordinal(row.rank)}: ${row.username}  (${
              row.tot_pts_won
            } pts)`
          );
        }

        let rtn = `
          <div class="marquee-item">
            <a href="/weekly-scores" class="marquee-link"><span class="marquee-label marquee-weekly-scores">Week ${this.latest_completed_week.play_week_num}</span></a>
            <span class="marquee-content">Winner: ${winner} - ${winningScore} points (${numRes} correct results, ${numScr} correct scores)</span>
          </div>`;

        rtn += `
          <div class="marquee-item">
            <a href="/weekly-scores" class="marquee-link"><span class="marquee-label marquee-weekly-scores">Week ${
              this.latest_completed_week.play_week_num
            }</span></a>
            <span class="marquee-content">${top_five} ${top_five_arr.join(
          '<span class="mx-4">-</span>'
        )}</span>
          </div>`;

        if (you) {
          rtn += `<div class="marquee-item">
            <a href="/weekly-scores" class="marquee-link"><span class="marquee-label marquee-weekly-scores">Week ${this.latest_completed_week.play_week_num}</span></a>
            <span class="marquee-content">Your Score: ${you.tot_pts_won} points (${you.num_correct_res} correct results, ${you.num_correct_scr} correct scores), ${rank} place this week</span>
          </div>`;
        }

        this.updateTkrWeek(rtn);
        this.weekReady = true;
        this.showTicky();
        return rtn;
      }
    },
    leagueInfo() {
      if (this.league) {
        let leeg = "Top Five: ";
        let leegArr = [];
        for (let i = 0; i < 5; i++) {
          let row = this.league[i];
          leegArr.push(
            `${this.ordinal(row.rank)}: ${row.username}  (${row.totPoints} pts)`
          );
        }
        let rtn = `
        <div class="marquee-item">
          <a href="/league" class="marquee-link"><span class="marquee-label marquee-league">League</span></a>
          <span class="marquee-content">${leeg} ${leegArr.join(
          '<span class="mx-4">-</span>'
        )}</span>
        </div>`;

        this.updateTkrLeague(rtn);
        this.leagueReady = true;
        this.showTicky();
        return rtn;
      }
    },
    sdInfo() {
      const sdee =
        "New season, new game. Everyone's alive - make sure you pick a winner!";

      let rtn = `
        <div class="marquee-item">
          <a href="/sudden-death" class="marquee-link"><span class="marquee-label marquee-sd">Sudden Death</span></a>
          <span class="marquee-content">${sdee}</span>
        </div>`;

      this.updateTkrSd(rtn);
      this.sdReady = true;
      this.showTicky();
      return rtn;
    },
    notices() {
      const msg =
        "Where's this new site then? Only a year late...";
      let rtn = `
        <div class="marquee-item">
          <a class="marquee-link"><span class="marquee-label marquee-nt">Coming soon...</span></a>
          <span class="marquee-content">${msg}</span>
        </div>`;

      this.updateTkrNotices(rtn);
      this.ntReady = true;
      this.showTicky();
      return rtn;
    },
  },
  methods: {
    ...mapActions([
      "getLatestCompletedWeek",
      "getLeague",
      "updateTkrWeek",
      "updateTkrLeague",
      "updateTkrSd",
      "updateTkrNotices",
    ]),
    showTicky() {
      // const status = this.weekReady && this.leagueReady && this.sdReady;
      const status = this.weekReady && this.leagueReady;
      this.showTicker = status;
      this.showTicker = true;
    },
    ordinal(num) {
      return numeral(num).format("0o");
    },
  },
  created() {
    if (!this.latest_completed_week) {
      this.getLatestCompletedWeek();
    }
    if (!this.league) {
      this.getLeague();
    }
  },
};
</script>

<style>
.hdn {
  visibility: hidden;
}

.marquee-item {
  margin: 0.3rem 5rem 0.3rem 0;
  display: inline-block;
}

.marquee-label {
  margin-right: 0.4rem;
  padding: 0.2rem 0.8rem;
  border: 1px solid black;
  border-radius: 5px;
}

.marquee-link {
  text-decoration: none;
}

.marquee-link span {
  color: black;
}

.marquee-link span.marquee-sd {
  color: whitesmoke;
}

.marquee-weekly-scores {
  background-color: var(--v-weekly_scores-base);
}

.marquee-league {
  background-color: var(--v-league-base);
}

.marquee-sd {
  background-color: var(--v-sd-base);
}

.marquee-nt {
  background-color: cyan;
}
</style>
